import { Component, Inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

export interface ItemDetailsDialogData {
  itemName: string;
  itemQuantity: string;
  itemGroupName: string;
  itemWhereToFindIt: string;
  imageUrl: string;
  itemGroupList: string[];
  readOnly?: boolean; // If true, show as read-only view
  isPublic?: boolean; // Public/private option
  userEmail?: string; // User email for private items
  showPublicPrivateOption?: boolean; // Show public/private checkbox
  showUserEmailOption?: boolean; // Show user email field for private items
}

@Component({
  selector: 'app-item-details-dialog',
  templateUrl: './item-details-dialog.component.html',
  styleUrls: ['./item-details-dialog.component.scss']
})
export class ItemDetailsDialogComponent {
  itemName: string = '';
  itemQuantity: string = '';
  itemGroupName: string = '';
  itemWhereToFindIt: string = '';
  imageUrl: string = '';
  readOnly: boolean = false;
  isPublic: boolean = true;
  userEmail: string = '';
  showPublicPrivateOption: boolean = false;
  showUserEmailOption: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ItemDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ItemDetailsDialogData
  ) {
    this.itemName = data.itemName || '';
    this.itemQuantity = data.itemQuantity || '';
    this.itemGroupName = data.itemGroupName || '';
    this.itemWhereToFindIt = data.itemWhereToFindIt || '';
    this.imageUrl = data.imageUrl || '';
    this.readOnly = data.readOnly || false;
    this.isPublic = data.isPublic !== undefined ? data.isPublic : true;
    this.userEmail = data.userEmail || '';
    this.showPublicPrivateOption = data.showPublicPrivateOption || false;
    this.showUserEmailOption = data.showUserEmailOption || false;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.itemName.trim()) {
      const result: any = {
        itemName: this.itemName.trim(),
        itemQuantity: this.itemQuantity.trim(),
        itemGroupName: this.itemGroupName.trim(),
        itemWhereToFindIt: this.itemWhereToFindIt.trim(),
      };
      
      // Include public/private and user email if these options are shown
      if (this.showPublicPrivateOption) {
        result.isPublic = this.isPublic;
      }
      if (this.showUserEmailOption && !this.isPublic) {
        result.userEmail = this.userEmail.trim();
      }
      
      this.dialogRef.close(result);
    }
  }

  onSelectItemGroup(event: any) {
    this.itemGroupName = event.option.value;
  }
}

